<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="form.valid && !form.pristine" [class.error]="!form.valid && !form.pristine">
                    Basic Information
                </h2>
            </div>
            <div>
                <mat-icon *ngIf="form.pristine && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="form.pristine && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && form.valid" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && !form.valid" class="header-toggle error">
                    close
                </mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body-container mx-2">
        <form [formGroup]="form">
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>First Name<span class="required-input">*</span></mat-label>
                        <input type="text" matInput formControlName="first_name">
                        <mat-error *ngIf="form.get('first_name')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Middle Name</mat-label>
                        <input type="text" matInput formControlName="middle_name">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Last Name<span class="required-input">*</span></mat-label>
                        <input type="text" matInput formControlName="last_name">
                        <mat-error *ngIf="form.get('last_name')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Birthdate</mat-label>
                        <input matInput [matDatepicker]="datePicker" formControlName="birth_date" [max]="maxBirthDate">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                        <mat-datepicker #datePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input type="text" matInput formControlName="phone" (input)="onPhoneNumberChanged($event)">
                        <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                        <mat-error *ngIf="form.controls['phone'].invalid">
                            Required format | (XXX) XXX-XXXX
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Email Address</mat-label>
                        <input type="text" matInput formControlName="email">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Driver License Number</mat-label>
                        <input type="text" matInput formControlName="driver_license">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>National Number</mat-label>
                        <input type="text" matInput formControlName="national_number">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>SSN</mat-label>
                        <input type="text" matInput formControlName="ssn">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Note</mat-label>
                        <textarea matInput formControlName="note"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</mat-expansion-panel>